// Importing necessary libraries and reducers
import { combineReducers } from "redux"; // Function to combine multiple reducers
import * as types from "../Actions/ActionTypes"; // Importing action type constants
import initialState from "./initailState"; // Initial state for the Redux store
import app from "./LoginReducer"; // Reducer for login-related state
import table from "./Table"; // Reducer for table-related state
import provideRegistration from "./ProviderRegistration"; // Reducer for provider registration
import roles from "./RoleReducer"; // Reducer for role-related state
import userRole from "./AppReducer"; // Reducer for user role-related state
import users from "./UserReducer"; // Reducer for user-related state
import merchantInformation from "./merchantInformation"; // Reducer for merchant information
import onBoarding from "./OnBoarding"; // Reducer for onboarding-related state
import paymentReducer from "./PaymentReducer"; // Reducer for payment-related state
import payout from "./payoutReducer"; // Reducer for payout-related state
import payoutReducer from "../../modules/payout/reducer/index"; // Reducers for payout module
import loader from "./LoaderReducer"; // Reducer for loader-related state

// Combining all reducers into a single reducer
const appReducer = combineReducers({
  userRole, // Reducer for user roles
  app, // Reducer for app state
  table, // Reducer for table state
  provideRegistration, // Reducer for provider registration
  merchantInformation, // Reducer for merchant information
  roles, // Reducer for roles
  onBoarding, // Reducer for onboarding
  users, // Reducer for users
  paymentReducer, // Reducer for payments
  loader, // Reducer for loader state
  payout, // Reducer for payouts
  ...payoutReducer, // Spread operator to include all reducers from the payout module
});

// Root reducer to handle global actions
const rootReducer = (state, action) => {
  // Reset the Redux store to its initial state when the REST_REDUCER_STATE action is dispatched
  if (action.type === types.REST_REDUCER_STATE) {
    const common = state.app.defaultTheme; // Preserve the default theme
    state = initialState; // Reset the state to the initial state
    state.app.defaultTheme = common; // Restore the default theme
  }
  return appReducer(state, action); // Pass the state and action to the combined reducers
};

// Exporting the root reducer
export default rootReducer;
